import { render } from "./index.vue?vue&type=template&id=18171812"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=18171812&lang=less"

import exportComponent from "D:\\项目\\王守岩代码\\长护险\\dp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__